(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kumoo-page-accordion"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kumoo-page-accordion')) {
  customElements.define('kumoo-page-accordion', class extends HTMLElement {
    connectedCallback() {
      this.initFrame = requestAnimationFrame(() => this.build());
    }
    disconnectedCallback() { cancelAnimationFrame(this.initFrame); }
    build() {
      const source = this.querySelector('.kpa-source');
      if (!source || source.dataset.enhanced === 'true') return;
      const categories = this.dataset.categories === 'true';
      const headings = Array.from(source.querySelectorAll(categories ? 'h2,h3' : 'h2'))
        .filter(h => !h.closest('details'));
      if (!headings.length) return;
      const output = document.createDocumentFragment();
      const hasContent = fragment => fragment.textContent.trim() || fragment.querySelector('img,video,table');
      const introRange = document.createRange();
      introRange.setStart(source, 0);
      introRange.setEndBefore(headings[0]);
      const introContent = introRange.cloneContents();
      if (hasContent(introContent)) {
        const intro = document.createElement('div');
        intro.className = 'kpa-intro';
        intro.append(introContent);
        output.append(intro);
      }
      let questionCount = 0;
      let inCategory = false;
      headings.forEach((heading, index) => {
        const range = document.createRange();
        range.setStartAfter(heading);
        if (headings[index + 1]) range.setEndBefore(headings[index + 1]);
        else range.setEnd(source, source.childNodes.length);
        const contents = range.cloneContents();
        if (categories && heading.tagName === 'H3') {
          inCategory = true;
          // Editor H3 marks a category; render H2 to keep an accessible outline.
          const category = document.createElement('h2');
          category.className = 'kpa-category';
          if (heading.id) category.id = heading.id;
          Array.from(heading.childNodes).forEach(node => category.append(node.cloneNode(true)));
          output.append(category);
          if (hasContent(contents)) {
            const intro = document.createElement('div');
            intro.className = 'kpa-group-intro';
            intro.append(contents);
            output.append(intro);
          }
          return;
        }
        const item = document.createElement('details');
        item.className = 'kpa-item';
        if (heading.id) item.id = heading.id;
        if (questionCount === 0 && this.dataset.firstOpen === 'true') item.open = true;
        questionCount++;
        const summary = document.createElement('summary');
        summary.className = 'kpa-summary';
        const label = document.createElement(inCategory ? 'h3' : 'h2');
        label.className = 'kpa-label';
        Array.from(heading.childNodes).forEach(node => label.append(node.cloneNode(true)));
        const icon = document.createElement('span');
        icon.className = 'kpa-icon';
        icon.setAttribute('aria-hidden', 'true');
        summary.append(label, icon);
        const body = document.createElement('div');
        body.className = 'kpa-body';
        body.append(contents);
        item.append(summary, body);
        output.append(item);
      });
      source.replaceChildren(output);
      source.dataset.enhanced = 'true';
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kumoo-scroll-rotation"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kumoo-scroll-rotation')) {
  customElements.define('kumoo-scroll-rotation', class extends HTMLElement {
    connectedCallback() { this.initFrame = requestAnimationFrame(() => this.initialize()); }
    initialize() {
      if (!this.isConnected || this.alive) return;
      this.alive = true;
      this.abort = new AbortController();
      this.canvas = this.querySelector('.kr-canvas');
      this.stage = this.querySelector('.kr-stage');
      this.sticky = this.querySelector('.kr-sticky');
      this.context = this.canvas.getContext('2d', {alpha: true});
      this.error = this.querySelector('.kr-error');
      this.cache = new Map(); this.loading = new Set(); this.failed = new Set();
      this.activeLoads = 0; this.queue = []; this.position = 0; this.target = 0;
      this.previousIndex = -1; this.visible = false; this.direction = 1;
      let list = '';
      try { list = JSON.parse(this.querySelector('.kr-urls').textContent || '""') || ''; } catch (_) {}
      const explicit = String(list).split(/\r?\n/).map(line => line.trim()).filter(Boolean);
      if (explicit.length) this.urls = explicit;
      else {
        const prefix = this.dataset.prefix || '';
        const suffix = this.dataset.suffix || '.webp';
        const first = Math.max(0, parseInt(this.dataset.start, 10) || 0);
        const count = Math.max(1, Math.min(300, parseInt(this.dataset.count, 10) || 120));
        const digits = Math.max(1, Math.min(6, parseInt(this.dataset.digits, 10) || 3));
        this.urls = prefix ? Array.from({length: count}, (_, i) => prefix + String(first + i).padStart(digits, '0') + suffix) : [];
      }
      this.urls = this.urls.filter(url => /^https?:\/\//i.test(url) || url.startsWith('/'));
      // Resize Shopify-hosted frames before downloading them. Preserve external URLs.
      const mobile = innerWidth < 750;
      this.cacheLimit = mobile ? 12 : 18;
      const resolution = Math.max(400, Number(mobile ? this.dataset.resolutionMobile : this.dataset.resolutionDesktop) || (mobile ? 1000 : 1600));
      this.urls = this.urls.map(source => {
        try {
          const url = new URL(source, location.href);
          if (url.hostname === 'cdn.shopify.com' || (url.origin === location.origin && url.pathname.startsWith('/cdn/shop/'))) {
            url.searchParams.set('width', String(resolution));
          }
          return url.href;
        } catch (_) { return source; }
      });
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.onScroll = () => {
        if (this.scrollFrame) return;
        this.scrollFrame = requestAnimationFrame(() => { this.scrollFrame = 0; this.measure(); });
      };
      document.addEventListener('scroll', this.onScroll, {capture:true, passive:true, signal:this.abort.signal});
      window.addEventListener('scroll', this.onScroll, {passive:true, signal:this.abort.signal});
      window.addEventListener('resize', this.onScroll, {signal:this.abort.signal});
      this.motion.addEventListener('change', this.onScroll, {signal:this.abort.signal});
      this.resize = new ResizeObserver(() => { this.resizeCanvas(); this.onScroll(); });
      this.resize.observe(this.stage);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        if (this.visible) { this.measure(); this.requestFrames(); }
      }, {rootMargin:'1200px 0px'});
      this.observer.observe(this);
      this.resizeCanvas(); this.measure();
      if (!this.urls.length) this.error.hidden = false;
    }
    resizeCanvas() {
      const rect = this.stage.getBoundingClientRect();
      const density = Math.min(devicePixelRatio || 1, innerWidth < 750 ? 1.5 : 2);
      const width = Math.max(1, Math.round(rect.width * density));
      const height = Math.max(1, Math.round(rect.height * density));
      if (this.canvas.width !== width || this.canvas.height !== height) {
        this.canvas.width = width; this.canvas.height = height;
        this.drawBest();
      }
    }
    measure() {
      if (!this.alive || !this.urls.length) return;
      if (this.dataset.reduced === 'true' && this.motion.matches) {
        this.target = 0; this.position = 0; this.requestFrames(); return;
      }
      const rect = this.getBoundingClientRect();
      const travel = Math.max(1, rect.height - this.sticky.offsetHeight);
      this.target = Math.max(0, Math.min(1, -rect.top / travel));
      if (!this.animationFrame) this.animate();
    }
    animate() {
      if (!this.alive) return;
      const smoothing = Math.max(0, Math.min(90, Number(this.dataset.smooth) || 0));
      const factor = Math.max(.13, 1 - smoothing / 100);
      const difference = this.target - this.position;
      this.position = Math.abs(difference) < .00035 ? this.target : this.position + difference * factor;
      this.requestFrames();
      if (Math.abs(this.target - this.position) >= .00035) {
        this.animationFrame = requestAnimationFrame(() => { this.animationFrame = 0; this.animate(); });
      }
    }
    requestFrames() {
      if (!this.visible || !this.urls.length) return;
      const last = this.urls.length - 1;
      const index = Math.max(0, Math.min(last, Math.round(this.position * last)));
      const targetIndex = Math.max(0, Math.min(last, Math.round(this.target * last)));
      if (index !== this.previousIndex) this.direction = Math.sign(index - this.previousIndex) || this.direction;
      this.previousIndex = index;
      this.drawBest();
      const direction = Math.sign(targetIndex - index) || this.direction;
      const wanted = [index, targetIndex];
      for (let offset = 1; offset <= this.cacheLimit; offset++) {
        wanted.push(index + offset * direction, index - offset * direction);
      }
      // Keep the requested window within cache capacity: otherwise stationary
      // prefetching continually evicts and reloads its own neighbours.
      this.wanted = [...new Set(wanted)].filter(n => n >= 0 && n <= last).slice(0, this.cacheLimit);
      this.queue = this.wanted.filter(n => n >= 0 && n <= last && !this.cache.has(n) && !this.loading.has(n) && !this.failed.has(n));
      this.pump();
    }
    pump() {
      while (this.alive && this.visible && this.activeLoads < 3 && this.queue.length) {
        const number = this.queue.shift();
        if (this.loading.has(number) || this.cache.has(number) || this.failed.has(number)) continue;
        const image = new Image();
        this.activeLoads++; this.loading.add(number);
        const done = success => {
          this.activeLoads--; this.loading.delete(number);
          if (!this.alive) return;
          if (success) {
            this.cache.delete(number); this.cache.set(number, image);
            while (this.cache.size > this.cacheLimit) {
              const unused = [...this.cache.keys()].filter(n => !this.wanted.includes(n));
              const candidates = unused.length ? unused : [...this.cache.keys()].filter(n => n !== this.previousIndex);
              const farthest = candidates.sort((a, b) => Math.abs(b - this.previousIndex) - Math.abs(a - this.previousIndex))[0];
              this.cache.delete(farthest);
            }
            this.drawBest();
          } else {
            this.failed.add(number);
            if (this.cache.size === 0) this.error.hidden = false;
          }
          this.requestFrames();
        };
        image.decoding = 'async';
        image.onload = () => {
          const decoded = image.decode ? image.decode() : Promise.resolve();
          decoded.then(() => done(true), () => done(true));
        };
        image.onerror = () => done(false);
        image.src = this.urls[number];
      }
    }
    drawBest() {
      if (!this.context || !this.cache || this.previousIndex < 0 || !this.cache.size) return;
      const exact = this.cache.get(this.previousIndex);
      const number = exact ? this.previousIndex : [...this.cache.keys()].reduce((best, n) => Math.abs(n - this.previousIndex) < Math.abs(best - this.previousIndex) ? n : best);
      if (this.renderedIndex === number && this.drawnWidth === this.canvas.width && this.drawnHeight === this.canvas.height && this.drawnZoom === this.zoom()) return;
      const image = this.cache.get(number);
      const width = this.canvas.width, height = this.canvas.height;
      const zoom = this.zoom();
      const trim = Math.max(0, Math.min(.4, Number(this.dataset.trimSides) / 100 || 0));
      const sourceX = image.naturalWidth * trim;
      const sourceWidth = image.naturalWidth - sourceX * 2;
      const scale = Math.min(width / sourceWidth, height / image.naturalHeight) * zoom;
      const drawWidth = sourceWidth * scale, drawHeight = image.naturalHeight * scale;
      this.context.clearRect(0, 0, width, height);
      this.context.drawImage(image, sourceX, 0, sourceWidth, image.naturalHeight, (width - drawWidth) / 2, (height - drawHeight) / 2, drawWidth, drawHeight);
      this.renderedIndex = number; this.drawnWidth = width; this.drawnHeight = height; this.drawnZoom = zoom;
      this.setAttribute('data-ready', ''); this.error.hidden = true;
    }
    zoom() {
      return Math.max(.5, Math.min(3, Number(innerWidth < 750 ? this.dataset.zoomMobile : this.dataset.zoomDesktop) / 100 || 1));
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.initFrame); cancelAnimationFrame(this.scrollFrame); cancelAnimationFrame(this.animationFrame);
      this.alive = false; this.abort?.abort(); this.resize?.disconnect(); this.observer?.disconnect();
      this.queue = []; this.cache?.clear();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kumoo-scroll-unfold"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kumoo-scroll-unfold')) {
  customElements.define('kumoo-scroll-unfold', class extends HTMLElement {
    connectedCallback() {
      this.initTick = requestAnimationFrame(() => this.initialize());
    }
    initialize() {
      if (!this.isConnected || !this.querySelector('.ku-sticky')) return;
      this.abort = new AbortController(); this.alive = true; this.progress = 0;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.status = this.querySelector('.ku-status');
      this.video = this.querySelector('video');
      this.error = this.querySelector('.ku-error'); this.canvas = this.querySelector('canvas');
      this.cache = new Map(); this.pending = []; this.loading = new Set(); this.failed = new Set(); this.activeLoads = 0;
      const options = {signal:this.abort.signal};
      this.measure = () => {
        if (!this.alive) return;
        if (this.reduced.matches && this.dataset.respectMotion === 'true') {this.setStatus('동작 줄이기 설정으로 정지됨 · 설정에서 해제할 수 있어요.');return;}
        const rect = this.getBoundingClientRect();
        const top = parseFloat(getComputedStyle(this).getPropertyValue('--ku-top')) || 0;
        const stickyHeight = this.querySelector('.ku-sticky').getBoundingClientRect().height;
        const travel = Math.max(1, rect.height - stickyHeight);
        this.setProgress(Math.max(0, Math.min(1, (top - rect.top)/travel)));
      };
      this.schedule = () => {if (!this.tick) this.tick = requestAnimationFrame(() => {this.tick=0;this.measure();});};
      document.addEventListener('scroll',this.schedule,{...options,passive:true,capture:true});
      window.addEventListener('scroll',this.schedule,{...options,passive:true});
      window.addEventListener('resize',this.schedule,options);
      this.reduced.addEventListener('change',this.schedule,options);
      this.resize = new ResizeObserver(this.schedule); this.resize.observe(this);
      if (this.video) {
        this.video.muted = true;
        this.setStatus('영상 로딩 중');
        if (!this.video.querySelector('source[src]')) this.setStatus('MP4 주소가 아직 없습니다 · 영상 처리 완료 후 다시 선택하세요.');
        this.video.addEventListener('canplay', () => this.seek(), options);
        this.video.querySelectorAll('source').forEach(source => source.addEventListener('error', () => this.setStatus('영상 주소를 불러오지 못했습니다 · 영상을 다시 선택하세요.'),options));
        this.video.addEventListener('loadeddata', () => {this.setAttribute('data-ready','');this.seek();}, options);
        this.video.addEventListener('loadedmetadata', () => this.seek(), options);
        this.video.addEventListener('seeked', () => this.seek(), options);
        this.video.addEventListener('error', () => {this.removeAttribute('data-ready');this.error.textContent='영상을 불러오지 못했습니다.';this.error.hidden=false;}, options);
        // Mobile Safari may require a user gesture before video decoding is enabled.
        this.addEventListener('pointerdown', () => {
          if (this.video.readyState < 2) {
            const play = this.video.play();
            if (play) play.then(() => {this.video.pause();this.seek();}).catch(() => {});
          }
        }, options);
        if (this.video.readyState >= 2) {this.setAttribute('data-ready','');this.seek();}
      } else {
        const value = JSON.parse(this.querySelector('.ku-frames').textContent || '""');
        this.urls = String(value || '').split(/\r?\n/).map(s=>s.trim()).filter(Boolean);
        this.context = this.canvas.getContext('2d');
        this.setStatus(this.urls.length ? `연속 이미지 ${this.urls.length}장 연결됨` : '연속 이미지 주소가 없습니다.');
        this.showFrame();
      }
      this.measure();
    }
    setStatus(message) {if(this.status)this.status.textContent=message;}
    setProgress(p) {
      this.progress=p;
      if(this.video && this.video.readyState>=2)this.setStatus('스크롤 연결됨 · 영상 준비 완료');
      if(this.video)this.seek();else this.showFrame();
    }
    seek() {
      const v=this.video;if(!v || !Number.isFinite(v.duration) || v.duration<=0 || v.seeking)return;
      const start=Math.max(0,Math.min(100,Number(this.dataset.start)))/100;
      const end=Math.max(start,Math.min(100,Number(this.dataset.end)))/100;
      const target=Math.min(v.duration-.04,v.duration*(start+(end-start)*this.progress));
      if(Math.abs(v.currentTime-target)>.025) v.currentTime=Math.max(0,target);
    }
    showFrame() {
      if(!this.urls || !this.urls.length)return;
      const start=Number(this.dataset.start)/100,end=Math.max(start,Number(this.dataset.end)/100);
      this.frame=Math.round((this.urls.length-1)*(start+(end-start)*this.progress));
      const image=this.cache.get(this.frame);
      if(image){this.canvas.width=image.naturalWidth;this.canvas.height=image.naturalHeight;this.context.drawImage(image,0,0);this.setAttribute('data-ready','');this.error.hidden=true;}
      else if(this.failed.has(this.frame)){this.error.hidden=false;}
      // Bound decoded memory and prioritize the current frame plus near neighbours.
      this.pending=[];
      for(let offset=0;offset<=6;offset++)for(const n of new Set([this.frame+offset,this.frame-offset])){
        if(n>=0 && n<this.urls.length && !this.cache.has(n) && !this.loading.has(n) && !this.failed.has(n))this.pending.push(n);
      }
      this.pump();
    }
    pump() {
      while(this.alive && this.activeLoads<4 && this.pending.length){
        const n=this.pending.shift(),image=new Image();this.loading.add(n);this.activeLoads++;
        const finish=(success)=>{
          this.activeLoads--;this.loading.delete(n);if(!this.alive)return;
          if(success){this.cache.set(n,image);if(this.cache.size>40){const farthest=[...this.cache.keys()].sort((a,b)=>Math.abs(b-this.frame)-Math.abs(a-this.frame))[0];this.cache.delete(farthest);}}
          else this.failed.add(n);
          this.showFrame();
        };
        image.onload=()=>finish(true);image.onerror=()=>finish(false);image.src=this.urls[n];
      }
    }
    disconnectedCallback(){cancelAnimationFrame(this.initTick);this.alive=false;this.abort?.abort();this.resize?.disconnect();cancelAnimationFrame(this.tick);this.video?.pause();this.cache?.clear();this.pending=[];}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
